module.exports = __webpack_public_path__ + "img/brunswick.0c0b6cc2.svg";